export * from './roles.builder';
export * from './roles-info.builder';
export var UserRoleAction;
(function (UserRoleAction) {
    UserRoleAction[UserRoleAction["ACCESS_KNOWLEDGEBASE"] = 10] = "ACCESS_KNOWLEDGEBASE";
    UserRoleAction[UserRoleAction["FETCH_ARTICLES"] = 20] = "FETCH_ARTICLES";
    UserRoleAction[UserRoleAction["CREATE_ARTICLES"] = 30] = "CREATE_ARTICLES";
    UserRoleAction[UserRoleAction["PUBLISH_ARTICLES"] = 40] = "PUBLISH_ARTICLES";
    UserRoleAction[UserRoleAction["DELETE_ARTICLES"] = 50] = "DELETE_ARTICLES";
    UserRoleAction[UserRoleAction["ACCESS_CATEGORIES"] = 60] = "ACCESS_CATEGORIES";
    UserRoleAction[UserRoleAction["FETCH_CATEGORIES"] = 70] = "FETCH_CATEGORIES";
    UserRoleAction[UserRoleAction["MANAGE_CATEGORIES"] = 80] = "MANAGE_CATEGORIES";
    // Tickets
    UserRoleAction[UserRoleAction["ACCESS_TICKETS"] = 90] = "ACCESS_TICKETS";
    UserRoleAction[UserRoleAction["FETCH_TICKETS"] = 100] = "FETCH_TICKETS";
    UserRoleAction[UserRoleAction["FETCH_TICKET_VIEWS"] = 109] = "FETCH_TICKET_VIEWS";
    UserRoleAction[UserRoleAction["MANAGE_SHARED_TICKET_VIEWS"] = 110] = "MANAGE_SHARED_TICKET_VIEWS";
    UserRoleAction[UserRoleAction["MANAGE_PRIVATE_TICKET_VIEWS"] = 111] = "MANAGE_PRIVATE_TICKET_VIEWS";
    UserRoleAction[UserRoleAction["CREATE_TICKETS"] = 120] = "CREATE_TICKETS";
    UserRoleAction[UserRoleAction["FILTER_TICKETS"] = 130] = "FILTER_TICKETS";
    UserRoleAction[UserRoleAction["CREATE_PHONE_TICKETS"] = 140] = "CREATE_PHONE_TICKETS";
    UserRoleAction[UserRoleAction["CREATE_CHAT_TICKETS"] = 141] = "CREATE_CHAT_TICKETS";
    UserRoleAction[UserRoleAction["CREATE_SMS_TICKETS"] = 142] = "CREATE_SMS_TICKETS";
    UserRoleAction[UserRoleAction["CREATE_AGENT_REPLIES"] = 150] = "CREATE_AGENT_REPLIES";
    UserRoleAction[UserRoleAction["CREATE_AGENT_INTERNAL_NOTE"] = 151] = "CREATE_AGENT_INTERNAL_NOTE";
    UserRoleAction[UserRoleAction["MANAGE_TICKETS"] = 160] = "MANAGE_TICKETS";
    UserRoleAction[UserRoleAction["BASIC_TICKET_ACTIONS"] = 161] = "BASIC_TICKET_ACTIONS";
    UserRoleAction[UserRoleAction["SNOOZE_TICKETS"] = 162] = "SNOOZE_TICKETS";
    UserRoleAction[UserRoleAction["MANAGE_TICKET_REPLIES"] = 163] = "MANAGE_TICKET_REPLIES";
    UserRoleAction[UserRoleAction["MERGE_TICKETS"] = 164] = "MERGE_TICKETS";
    UserRoleAction[UserRoleAction["DELETE_TICKETS"] = 165] = "DELETE_TICKETS";
    UserRoleAction[UserRoleAction["CHANGE_TICKET_BRAND"] = 166] = "CHANGE_TICKET_BRAND";
    UserRoleAction[UserRoleAction["FETCH_SAVED_REPLIES"] = 170] = "FETCH_SAVED_REPLIES";
    UserRoleAction[UserRoleAction["MANAGE_SHARED_SAVED_REPLIES"] = 180] = "MANAGE_SHARED_SAVED_REPLIES";
    // Chat
    UserRoleAction[UserRoleAction["ACCESS_CHAT"] = 190] = "ACCESS_CHAT";
    UserRoleAction[UserRoleAction["FETCH_CHAT_TICKETS"] = 200] = "FETCH_CHAT_TICKETS";
    UserRoleAction[UserRoleAction["PARTICIPATE_IN_CHATS"] = 210] = "PARTICIPATE_IN_CHATS";
    UserRoleAction[UserRoleAction["FILTER_CHATS"] = 220] = "FILTER_CHATS";
    UserRoleAction[UserRoleAction["FETCH_CHAT_VIEWS"] = 229] = "FETCH_CHAT_VIEWS";
    UserRoleAction[UserRoleAction["MANAGE_CHAT_VIEWS"] = 230] = "MANAGE_CHAT_VIEWS";
    // Call Center
    UserRoleAction[UserRoleAction["ACCESS_CALLCENTER"] = 240] = "ACCESS_CALLCENTER";
    UserRoleAction[UserRoleAction["OPERATE_CALLS"] = 245] = "OPERATE_CALLS";
    UserRoleAction[UserRoleAction["PAUSE_CALL_RECORDING"] = 246] = "PAUSE_CALL_RECORDING";
    UserRoleAction[UserRoleAction["FETCH_CALLS"] = 250] = "FETCH_CALLS";
    UserRoleAction[UserRoleAction["BE_ASSIGNED_TO_QUEUES"] = 260] = "BE_ASSIGNED_TO_QUEUES";
    UserRoleAction[UserRoleAction["PERFORM_OUTBOUND_CALLS"] = 270] = "PERFORM_OUTBOUND_CALLS";
    UserRoleAction[UserRoleAction["AUDIT_LIVE_CALLS"] = 280] = "AUDIT_LIVE_CALLS";
    UserRoleAction[UserRoleAction["AUDIT_CALL_RECORDINGS"] = 290] = "AUDIT_CALL_RECORDINGS";
    UserRoleAction[UserRoleAction["MANAGE_QUEUE_ASSIGNMENTS"] = 300] = "MANAGE_QUEUE_ASSIGNMENTS";
    UserRoleAction[UserRoleAction["DELETE_CALL_RECORDINGS"] = 310] = "DELETE_CALL_RECORDINGS";
    UserRoleAction[UserRoleAction["FETCH_CALL_RECORDINGS"] = 320] = "FETCH_CALL_RECORDINGS";
    // Contacts + Companies
    UserRoleAction[UserRoleAction["ACCESS_CONTACTS"] = 330] = "ACCESS_CONTACTS";
    UserRoleAction[UserRoleAction["FETCH_CONTACTS"] = 340] = "FETCH_CONTACTS";
    UserRoleAction[UserRoleAction["MANAGE_CONTACTS"] = 350] = "MANAGE_CONTACTS";
    UserRoleAction[UserRoleAction["ACCESS_COMPANIES"] = 360] = "ACCESS_COMPANIES";
    UserRoleAction[UserRoleAction["FETCH_COMPANIES"] = 370] = "FETCH_COMPANIES";
    UserRoleAction[UserRoleAction["MANAGE_COMPANIES"] = 380] = "MANAGE_COMPANIES";
    // Insights
    UserRoleAction[UserRoleAction["FETCH_INSIGHTS"] = 390] = "FETCH_INSIGHTS";
    UserRoleAction[UserRoleAction["FETCH_TEAM_PERFORMANCE"] = 400] = "FETCH_TEAM_PERFORMANCE";
    UserRoleAction[UserRoleAction["FETCH_ADVANCED_REPORTS"] = 401] = "FETCH_ADVANCED_REPORTS";
    // Settings
    UserRoleAction[UserRoleAction["MANAGE_HELP_CENTER_SETTINGS"] = 410] = "MANAGE_HELP_CENTER_SETTINGS";
    UserRoleAction[UserRoleAction["FETCH_CALLCENTER_SETTINGS"] = 420] = "FETCH_CALLCENTER_SETTINGS";
    UserRoleAction[UserRoleAction["MANAGE_CALLCENTER_SETTINGS"] = 430] = "MANAGE_CALLCENTER_SETTINGS";
    UserRoleAction[UserRoleAction["FETCH_WIDGET"] = 440] = "FETCH_WIDGET";
    UserRoleAction[UserRoleAction["MANAGE_WIDGET"] = 450] = "MANAGE_WIDGET";
    UserRoleAction[UserRoleAction["FETCH_MAILBOXES"] = 460] = "FETCH_MAILBOXES";
    UserRoleAction[UserRoleAction["MANAGE_MAILBOXES"] = 470] = "MANAGE_MAILBOXES";
    UserRoleAction[UserRoleAction["MANAGE_FACEBOOK_SETTINGS"] = 480] = "MANAGE_FACEBOOK_SETTINGS";
    UserRoleAction[UserRoleAction["FETCH_TICKETS_CUSTOM_FIELDS"] = 490] = "FETCH_TICKETS_CUSTOM_FIELDS";
    UserRoleAction[UserRoleAction["MANAGE_TICKETS_CUSTOM_FIELDS"] = 500] = "MANAGE_TICKETS_CUSTOM_FIELDS";
    UserRoleAction[UserRoleAction["FETCH_USERS_CUSTOM_FIELDS"] = 510] = "FETCH_USERS_CUSTOM_FIELDS";
    UserRoleAction[UserRoleAction["MANAGE_USERS_CUSTOM_FIELDS"] = 520] = "MANAGE_USERS_CUSTOM_FIELDS";
    UserRoleAction[UserRoleAction["FETCH_COMPANIES_CUSTOM_FIELDS"] = 530] = "FETCH_COMPANIES_CUSTOM_FIELDS";
    UserRoleAction[UserRoleAction["MANAGE_COMPANIES_CUSTOM_FIELDS"] = 540] = "MANAGE_COMPANIES_CUSTOM_FIELDS";
    UserRoleAction[UserRoleAction["FETCH_AGENTS_CUSTOM_FIELDS"] = 550] = "FETCH_AGENTS_CUSTOM_FIELDS";
    UserRoleAction[UserRoleAction["MANAGE_AGENTS_CUSTOM_FIELDS"] = 560] = "MANAGE_AGENTS_CUSTOM_FIELDS";
    UserRoleAction[UserRoleAction["MANAGE_RULE_ENGINE"] = 570] = "MANAGE_RULE_ENGINE";
    UserRoleAction[UserRoleAction["MANAGE_EMAIL_TEMPLATES"] = 580] = "MANAGE_EMAIL_TEMPLATES";
    UserRoleAction[UserRoleAction["MANAGE_WEBHOOKS_AND_API_SETTINGS"] = 590] = "MANAGE_WEBHOOKS_AND_API_SETTINGS";
    UserRoleAction[UserRoleAction["FETCH_INTEGRATIONS"] = 600] = "FETCH_INTEGRATIONS";
    UserRoleAction[UserRoleAction["MANAGE_INTEGRATIONS"] = 610] = "MANAGE_INTEGRATIONS";
    UserRoleAction[UserRoleAction["FETCH_LABELS"] = 620] = "FETCH_LABELS";
    UserRoleAction[UserRoleAction["MANAGE_LABELS"] = 630] = "MANAGE_LABELS";
    UserRoleAction[UserRoleAction["FETCH_TEAM_MEMBERS"] = 640] = "FETCH_TEAM_MEMBERS";
    UserRoleAction[UserRoleAction["MANAGE_TEAM_MEMBERS"] = 650] = "MANAGE_TEAM_MEMBERS";
    UserRoleAction[UserRoleAction["MANAGE_GROUP_ASSIGNMENTS"] = 651] = "MANAGE_GROUP_ASSIGNMENTS";
    UserRoleAction[UserRoleAction["MANAGE_ROLES_AND_PERMISSIONS"] = 660] = "MANAGE_ROLES_AND_PERMISSIONS";
    UserRoleAction[UserRoleAction["FETCH_MACROS"] = 670] = "FETCH_MACROS";
    UserRoleAction[UserRoleAction["MANAGE_MACROS"] = 680] = "MANAGE_MACROS";
    UserRoleAction[UserRoleAction["FETCH_ACCOUNT"] = 690] = "FETCH_ACCOUNT";
    UserRoleAction[UserRoleAction["MANAGE_ACCOUNT"] = 700] = "MANAGE_ACCOUNT";
    UserRoleAction[UserRoleAction["FETCH_SLA"] = 710] = "FETCH_SLA";
    UserRoleAction[UserRoleAction["MANAGE_SLA"] = 720] = "MANAGE_SLA";
    UserRoleAction[UserRoleAction["FETCH_WHATSAPP"] = 730] = "FETCH_WHATSAPP";
    UserRoleAction[UserRoleAction["MANAGE_WHATSAPP"] = 740] = "MANAGE_WHATSAPP";
    UserRoleAction[UserRoleAction["END_TICKET_SESSIONS"] = 750] = "END_TICKET_SESSIONS";
    UserRoleAction[UserRoleAction["FETCH_CSAT_SETTINGS"] = 760] = "FETCH_CSAT_SETTINGS";
    UserRoleAction[UserRoleAction["MANAGE_CSAT_SETTINGS"] = 770] = "MANAGE_CSAT_SETTINGS";
    UserRoleAction[UserRoleAction["FETCH_CONTROL_ROOM"] = 780] = "FETCH_CONTROL_ROOM";
    UserRoleAction[UserRoleAction["FETCH_AUTO_ROUTING_SETTINGS"] = 790] = "FETCH_AUTO_ROUTING_SETTINGS";
    UserRoleAction[UserRoleAction["MANAGE_AUTO_ROUTING_SETTINGS"] = 800] = "MANAGE_AUTO_ROUTING_SETTINGS";
    UserRoleAction[UserRoleAction["MANAGE_ADMIN_AUTO_ROUTING_SETTINGS"] = 810] = "MANAGE_ADMIN_AUTO_ROUTING_SETTINGS";
    UserRoleAction[UserRoleAction["MANAGE_CHANNEL_ASSIGNMENT"] = 811] = "MANAGE_CHANNEL_ASSIGNMENT";
    UserRoleAction[UserRoleAction["MANAGE_CHANNEL_WORKLOAD"] = 812] = "MANAGE_CHANNEL_WORKLOAD";
    UserRoleAction[UserRoleAction["MANAGE_TICKETS_HANDLING"] = 813] = "MANAGE_TICKETS_HANDLING";
    UserRoleAction[UserRoleAction["MANAGE_AGENT_AUTO_ROUTING_SETTINGS"] = 820] = "MANAGE_AGENT_AUTO_ROUTING_SETTINGS";
    UserRoleAction[UserRoleAction["FETCH_AGENT_AUTO_ROUTING_SETTINGS"] = 830] = "FETCH_AGENT_AUTO_ROUTING_SETTINGS";
    UserRoleAction[UserRoleAction["CHANGE_STATUS_OF_OTHER_AGENTS"] = 831] = "CHANGE_STATUS_OF_OTHER_AGENTS";
    UserRoleAction[UserRoleAction["FETCH_SPOTTER"] = 840] = "FETCH_SPOTTER";
    UserRoleAction[UserRoleAction["MANAGE_SPOTTER"] = 850] = "MANAGE_SPOTTER";
    UserRoleAction[UserRoleAction["MANAGE_AUTH_PROVIDER_SETTINGS"] = 860] = "MANAGE_AUTH_PROVIDER_SETTINGS";
    UserRoleAction[UserRoleAction["MANAGE_BUSY_STATUS_SETTINGS"] = 870] = "MANAGE_BUSY_STATUS_SETTINGS";
    UserRoleAction[UserRoleAction["MANAGE_TWITTER_SETTINGS"] = 930] = "MANAGE_TWITTER_SETTINGS";
    UserRoleAction[UserRoleAction["MANAGE_INSTAGRAM_SETTINGS"] = 950] = "MANAGE_INSTAGRAM_SETTINGS";
})(UserRoleAction || (UserRoleAction = {}));
export var AllSettingsActions = [
    UserRoleAction.MANAGE_HELP_CENTER_SETTINGS,
    UserRoleAction.MANAGE_CALLCENTER_SETTINGS,
    UserRoleAction.MANAGE_WIDGET,
    UserRoleAction.MANAGE_MAILBOXES,
    UserRoleAction.MANAGE_FACEBOOK_SETTINGS,
    UserRoleAction.MANAGE_TWITTER_SETTINGS,
    UserRoleAction.MANAGE_INSTAGRAM_SETTINGS,
    UserRoleAction.MANAGE_TICKETS_CUSTOM_FIELDS,
    UserRoleAction.MANAGE_USERS_CUSTOM_FIELDS,
    UserRoleAction.MANAGE_COMPANIES_CUSTOM_FIELDS,
    UserRoleAction.MANAGE_AGENTS_CUSTOM_FIELDS,
    UserRoleAction.MANAGE_RULE_ENGINE,
    UserRoleAction.MANAGE_EMAIL_TEMPLATES,
    UserRoleAction.MANAGE_WEBHOOKS_AND_API_SETTINGS,
    UserRoleAction.MANAGE_INTEGRATIONS,
    UserRoleAction.MANAGE_LABELS,
    UserRoleAction.MANAGE_SPOTTER,
    UserRoleAction.MANAGE_TEAM_MEMBERS,
    UserRoleAction.MANAGE_ROLES_AND_PERMISSIONS,
    UserRoleAction.MANAGE_MACROS,
    UserRoleAction.MANAGE_ACCOUNT,
    UserRoleAction.MANAGE_SLA,
    UserRoleAction.MANAGE_WHATSAPP,
    UserRoleAction.MANAGE_CSAT_SETTINGS,
    UserRoleAction.MANAGE_AUTO_ROUTING_SETTINGS,
    UserRoleAction.MANAGE_AGENT_AUTO_ROUTING_SETTINGS,
];
export var ADMIN_ID = '00000000-0000-0000-0000-000000000030';
export var FULL_PERMISSIONS = Object.keys(UserRoleAction)
    .filter(function (key) { return typeof UserRoleAction[key] === 'number'; })
    .map(function (key) { return parseInt(UserRoleAction[key], 10); });
export var AdminRole = {
    id: ADMIN_ID,
    name: 'Admin',
    description: 'Can configure all features through the Admin tab, but is restricted from viewing Account or Billing related information.',
    editable: false,
    creationDate: 8888888,
    lastUpdateDate: 999999999,
    permissionsData: {
        permissions: FULL_PERMISSIONS
    }
};
export var AdminRoleInfo = {
    id: ADMIN_ID,
    name: 'Admin',
    description: 'Can configure all features through the Admin tab, but is restricted from viewing Account or Billing related information.',
    editable: false,
    creationDate: 8888888,
    lastUpdateDate: 999999999,
    agentsCount: 100
};
export var AgentRole = {
    id: '00000000-0000-0000-0000-000000000010',
    name: 'Agent',
    description: 'Can log, view, reply, update and resolve tickets and manage contacts.',
    editable: false,
    creationDate: 8888888,
    lastUpdateDate: 999999999,
    permissionsData: {
        permissions: []
    }
};
var rolesRelativePath = '/roles';
export var createUserRolesApi = function (baseUrl, http) {
    var apiUrl = baseUrl + rolesRelativePath;
    return {
        add: function (addUserRoleDto) { return http.post(apiUrl, addUserRoleDto); },
        update: function (updateUserRoleDto) { return http.put(apiUrl + "/" + updateUserRoleDto.id, updateUserRoleDto); },
        get: function (id) { return http.get(apiUrl + "/" + id); },
        getAll: function () { return http.get("" + apiUrl); },
        delete: function (deleteUserRoleDto) {
            var maybeNewRoleId = !!deleteUserRoleDto.newRoleId ? "?newRoleId=" + deleteUserRoleDto.newRoleId : '';
            return http.delete(apiUrl + "/" + deleteUserRoleDto.id + "/" + maybeNewRoleId);
        }
    };
};
//# sourceMappingURL=index.js.map